import { store } from './../index';
import { Pages } from './../constants/actionType';
import { redirectTo } from './../action/redirection';
import { logOtherInfo,detailsInfo, logToKibanna } from './../service/logService'
import MP, { MP_const } from '../constants/espanol';
import { getCookieVisitIdAndVisitorId, getCookieCommonLQ, resetCurrentRequest } from './../service/apiService';
import constants from '../containers/midnight/perks/constants';
import { buildQueryString } from '../action/changeApp';
export class InHomeUtils {
    static history;

    static setHistory (val) {
        InHomeUtils.history = val;
    }

    static getValueAsString(value) {
        if (value !== undefined && value !== null) {
            return value.toString();
        }
        return "";
    }
    
    static parseIHCookie(iHCookie, cookieName){
        iHCookie = decodeURIComponent(iHCookie);
        let cookieValue = '';
        const startIdx = iHCookie.indexOf(cookieName);
        if(startIdx > -1) {
            const startPosition = startIdx + cookieName.length;
            const endPosition = iHCookie.slice(startPosition).indexOf(';');
            cookieValue = (endPosition > -1) ? iHCookie.slice(startPosition, startPosition + endPosition) : iHCookie.slice(startPosition);
        } 
        return cookieValue;
    }
    static deleteIHCookie(iHCookie, cookieName){
        iHCookie = decodeURIComponent(iHCookie);
        const startIdx = iHCookie.indexOf(cookieName);
        if(startIdx > -1) {
            const startPosition = startIdx + cookieName.length;
            const endPosition = iHCookie.slice(startPosition).indexOf(';');
            document.cookie = (endPosition > -1) ? document.cookie.slice(0, startPosition).concat(document.cookie.slice(endPosition+1)) : document.cookie.slice(0, startPosition);
        } 
    }

    static isFlowTypeCheckMoves() {
        const flowType = store && store.getState && store.getState().app && store.getState().app.flowType;        
        if (flowType && flowType === "MV") {
            return true;
        }
        else {
            return false;
        }
    }

    static flowCheckforSeamless(){
        const flowType = store && store.getState && store.getState().cart && store.getState().cart.cartOrderProperty;
        const isSeamlessFlow = store && store.getState && store.getState().moveExp && store.getState().moveExp.cust_opt;
        if ((flowType && flowType.toLowerCase() === "seamless") || (isSeamlessFlow && isSeamlessFlow.toLowerCase() == "seamless")) {
            return true;
        }
        else {
            return false;
        }
    }

    static isFcpFlow(){
        const isFcpFlow = store && store.getState && store.getState().loopQual && store.getState().loopQual.isFCPflow;
        if(isFcpFlow){
            return true;
        }
        else{
            return false;
        }
    }
    
    static isFcpUEO(){
        const isFcpUEO = store && store.getState && store.getState().loopQual && store.getState().loopQual.runtimeKey && store.getState().loopQual.runtimeKey.FcpinUEO;
        if(isFcpUEO === "Y"){
            return true;
        }
        else{
            return false;
        }
    }


    static isFCPInProfile(){
        const isFcpinProfile = store && store.getState && store.getState().loopQual && store.getState().loopQual.isFcpInProfile;
        const isSeamlessFlow = store && store.getState && store.getState().moveExp && store.getState().moveExp.cust_opt;
        const moveExp = store && store.getState && store.getState().moveExp && store.getState().moveExp.moveLandingExp && store.getState().moveExp.moveLandingExp.movesEligibility;
        if ((isSeamlessFlow && isSeamlessFlow.toLowerCase() == "seamless") && !isFcpinProfile) {
            return true;
        }
        else if((moveExp && moveExp.toLowerCase() == "seamless") && !isFcpinProfile){
            return true;
        }else{
            return false;
        }
    }

    static isArray(value) {
        if(Array.isArray(value)) {
            return true
        }
        return false;
    }

    static isNull(value) {
        if (value === undefined || value === null) {
            return true;
        }
        return false;
    }

    static isNotNull(value) {
        if(typeof value !== 'string' && value !== undefined && value !== null){
            return true;
        }
        else if (typeof value === 'string' && value !== undefined){
            return true;
        }
        return false;
    }

    static isNotEmpty(value) {
        if (value !== undefined && value !== null && value !== '') {
            return true;
        }
        return false;
    }

    static getIndexOf(value, srchString) {
        if (value !== undefined && value !== null) {
            if (value.toString().indexOf(srchString) > -1)
                return true;
            else
                return false;
        }
        else { return false; }
    }

    static isNotNullObjects(obj /*, level1, level2, ... levelN*/) {
        try {
            var args = Array.prototype.slice.call(arguments, 1);

            for (var i = 0; i < args.length; i++) {
                if (!obj || !obj.hasOwnProperty(args[i])) {
                    return false;
                }
                obj = obj[args[i]];
            }
            return true;
        }
        catch (e) { return false; }
    }

    static arrayIncludes(array, value) {
        if (array.includes) {
            return array.includes(value);
        }
        else {
            return array.indexOf(value) > -1 ? true : false;
        }
    }

    static exitFiosReferral() {
        const hostedAttractLoop = sessionStorage.getItem("hostedAttractLoop") === "true";
        try {
            InHomeUtils.clearMemory();  
          } catch(ex) {
            console.log(ex);
          }  finally {
            localStorage?.clear();
            sessionStorage?.clear();      
            if (window.location.host === 'espanolstage.verizon.com' || window.location.host === 'espanol.verizon.com') {
                if(hostedAttractLoop) {
                    if(window.external && window.external.notifyPlanbuilder) {
                        window.external.notifyPlanbuilder(JSON.stringify({action: "close"}));
                    }
                } else {
                    InHomeUtils.epsonalDomainClick();
                }
            } else if(hostedAttractLoop) {
                if(window.external && window.external.notifyPlanbuilder) {
                    window.external.notifyPlanbuilder(JSON.stringify({action: "close"}));
                }
            }else if (InHomeUtils.history){
                InHomeUtils.history.push({
                  pathname: `/inhome/fiosreferral`,
                });
                window.location.reload(true);
            }
          }
    }

    static getCookie(cname, cookies) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(cookies);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    static deleteCookie = (name) => {
        const date = new Date();
        date.setTime(date.getTime() + -3 * 24 * 60 * 60 * 1000);
        document.cookie = `${name}=;path=/;expires=${date.toGMTString()}`;
      };

    static epsonalDomainClick() {
        console.log('insideEspanolDomain');      
        //let value = window.sessionStorage.getItem('persist:root');
        //let arrayVal=''; let arrayValtemp='';          
        let visit_id = MP.getCookie('visit_id');
        let visitor_id = MP.getCookie('visitor_id');
        //let data = '';
        let relativePath = '/inhome/fiosreferral';

        let SrcURL = ''
        let domainURL = 'https://www.verizon.com'; // To avoid motion point team not to make it change domain while converting
        let locHost = window.location.host;
        let locPathName = window.location.pathname;
        if (sessionStorage.getItem("fiosReferralFlow") === "true") {
            if (locHost === 'espanol.verizon.com') {
                domainURL = 'https://' + 'https://www.verizon.com';
            } else if (locHost === 'espanolstage.verizon.com') {
                domainURL = 'https://' + 'https://www98.verizon.com';
            }
        }
        console.log('**********************');
        console.log(domainURL + locPathName)
        if (locHost === 'espanol.verizon.com' || locHost === 'espanolstage.verizon.com') {
            if (relativePath === locPathName) {
                if (window.location.search)
                    SrcURL = encodeURIComponent(domainURL + locPathName + window.location.search);
                else
                    SrcURL = encodeURIComponent(domainURL + locPathName)
            }
            else if(locPathName==='/inhome/brtc'){
                SrcURL = encodeURIComponent(domainURL + locPathName + window.location.search);
            }
            else
                SrcURL = encodeURIComponent(domainURL + relativePath);

            let persitCookieSet = MP.getCookie('persitSetItem');
            if (persitCookieSet !== undefined && persitCookieSet !== null && persitCookieSet === "Y") {
                if (window.location.search)
                    SrcURL = encodeURIComponent(domainURL + locPathName + window.location.search);
                else
                    SrcURL = encodeURIComponent(domainURL + locPathName);
            }
            else if ((typeof MP !== 'undefined') && (typeof MP.setCookie !== 'undefined') && persitCookieSet !== "Y") {
                // MP.setCookie('persitSetItem', 'Y', '/', domain);                        
                window.sessionStorage.setItem('persist:root', "")
            }
        }
        //MP_const.SrcUrl=unescape('https%3A%2F%2Fwww.verizon.com%2Finhome%2Fqualification');
        MP_const.SrcUrl = unescape(SrcURL);
        MP.SrcUrl = unescape(SrcURL);
        MP.UrlLang = 'es';
        MP.init();
        return MP_const.switchLanguage('en', visit_id, visitor_id);
}

    static clearMemory() {
        let visitId = store.getState().app.visitId;
        let pageName = store.getState().app.currentPage.pathname;
        let allSessionStorageItems = ['visit_id','visitor_id','fiosInABox','ExistingFIOS_isVZWWireless','persist:root','selectedAddress','Reskin','tokenValidUpto','token','VstExpiryPath','countrycode','prefSt','dma','commonLQ'];
        let allLocalStorageItems = ['visit_id','visitor_id','expirationTime','isvtokenvalidated','mfrt_visit_id','count','mnh_indicator','vendorflow','persist:root'];
        logOtherInfo(detailsInfo(pageName, visitId, 'clearMemory', 'Clearing both cookie and redux','USERACTION'));
        //window.sessionStorage.clear();  
        //window.localStorage.clear();  
        allSessionStorageItems.forEach((item)=>{
            window.sessionStorage.removeItem(item);
        })
        allLocalStorageItems.forEach((key)=>{
            window.localStorage.removeItem(key);
        })
        clearCookies();
        store.dispatch({type:'CLEAR_STORE',value:null});
    } 
    
    static redirectToHomePage(queryString=""){
        if(window.location.pathname && (window.location.pathname.indexOf('/change/supp/') > -1)){
            redirectTo(Pages.LBO+"?Message=visitidempty-supp", store.dispatch)
        }
        else if (queryString!==""){
            redirectTo(Pages.CheckLQ2VisitIdEmpty + "&"+queryString, store.dispatch)
            logToKibanna("Redirecting to LQ as visit id is empty")
        }
        else if (window.location.search && !(window.location.search.indexOf('visitidempty') !== -1)){
            redirectTo(Pages.CheckLQ2dotO + window.location.search + "&message=visitidempty", store.dispatch)
            logToKibanna("Redirecting to LQ as visit id is empty")
        }
        else 
            redirectTo(Pages.CheckLQ2VisitIdEmpty, store.dispatch)
        //window.location.reload();
    }

    static setIntervalForGetMon(lqState, visitId, dispatch, setIntervalForMON) {
        const stateFromLq = lqState.selectedState && lqState.selectedState.state || '' ;
        if(!stateFromLq) {
            const eligible = lqState.servicesQualified && ( lqState.servicesQualified.isDataQualified ||  lqState.servicesQualified.isVideoQualified ||  lqState.servicesQualified.isVoiceQualified);
            if(eligible) {
                // buildProductAction.getMon(dispatch, visitId, stateFromLq, setIntervalForMON);
            }else{
                window.clearInterval(setIntervalForMON);
                InHomeUtils.clearMemory();
                InHomeUtils.redirectToHomePage();
            }
        }else {
            // buildProductAction.getMon(dispatch, visitId, stateFromLq, setIntervalForMON);
        }
    }

    static visitIdCheck(cookieVisitID) {
        try{ 
            let flowType = store && store.getState && store.getState().app && store.getState().app.flowType;
            let enableVisitEmptyCheck = store && store.getState && store.getState().loopQual && store.getState().loopQual.runtimeKey && store.getState().loopQual.runtimeKey.EnableVisitEmptyCheck;
            let inputDetail = store && store.getState && store.getState().app && store.getState().app.queryString; 
                    
            if(enableVisitEmptyCheck === 'Y' && (flowType === 'NC' || flowType === 'AF' ) && (cookieVisitID === null || cookieVisitID === '' || cookieVisitID === undefined)) {
                InHomeUtils.clearMemory();
                resetCurrentRequest();
                if(flowType === 'NC') { InHomeUtils.redirectToHomePage();}
                if(flowType === 'AF') {
                    if(inputDetail === '') {
                        const qstring = {
                            FlowType: 'accordion',
                            SourceType: 'urc',
                        }
                        inputDetail = buildQueryString(qstring)
                    }
                    redirectTo(Pages.SignIn + "?" + inputDetail, store.dispatch);
                }
            }
        } catch(error) {
            console.log(error)
        }
    }
    static getdeviceType() {
        let deviceType = 'desktop';
        let userAgent = window.navigator.userAgent.toLowerCase();
        if (userAgent && (userAgent.indexOf('android') !== -1 || userAgent.indexOf('iphone') !== -1)) {
            deviceType = "mobile";
        }
        return deviceType;
    }

    
    static prepareHoaNotification  (title) {
        if(InHomeUtils.isNotEmpty(title)){
            return {
                title : `As a Verizon Enhanced Communities Value Program customer, your offer includes ${title}`,
                notificationType : 'info'
            }
        }
        return null;
    }
    static prepareSLONotification  (title) {
        if(InHomeUtils.isNotEmpty(title)){
            return {
                title :title,
                notificationType : 'error'
            }
        }
        return null;
    }
    static getVzfwdOfferName = (promoId) => {
        if (promoId === "R3601") {
            return "Verizon Forward credit"
        }
        else if (promoId === "R3484" || promoId==='R4437' || promoId==='R4136') {
            return "Verizon Forward"
        }
        else if (promoId === "R4071" || promoId==='R4072') {
            return "Verizon Forward - NY"
        } else if(promoId === "R4186"){
            return "Mobile + Home Discount(Internet)"
        }
    }
    static vzFwdOfferIds = ["R3484", "R3601", "R4437", "R4071", "R4072", "R4186", "R4136"]

    static getInternetDetailName = (promoId) => {
        if (promoId === "R3587" || promoId === "R3586") {
            return "300 mbps"
        }
        else if (promoId === "R3585" || promoId === "R3584" ) {
            return "500 mbps"
        }
        else if (promoId === "R3583" ) {
            return "1 gig"
        } else if(promoId === "R3582"){
            return "2 gig"
        }
        else if(promoId === "R3588" || promoId === "R3589" || promoId ==="R3591"){
            return "100 mbps"
        }
        else if(promoId === 'J5299'){
            return "Internet 100 mbps";
        }
        else if(promoId === "R2806"){
            return "Internet 300 mbps"
        }
        else if(promoId === "R2809" || promoId === "J5301"){
            return "Internet 500 mbps"
        }
        else if(promoId === "P5882"){
            return "Gigabit connection"
        }
    }

    static getMnmInternetDetailNameEC = (productName) => {
        if (productName?.includes('100') && productName?.includes('mbps'))
            return '100 mbps';
        else if (productName?.includes('300') && productName?.includes('mbps'))
            return '300 mbps';
        else if (productName?.includes('500') && productName?.includes('mbps'))
            return '500 mbps';
        else if (productName?.includes('1') && productName?.includes('gig'))
            return '1 gig';
        else if (productName?.includes('2') && productName?.includes('gig'))
            return '2 gig';
        else 
            return productName;
    }

    static getVzfwdDisplayPrice = (buildProduct, discountPrice , hasNYdiscount=false) => {
        try {
            const vzfwd_floor_price = 19.99
            const vzfwd_NY_floor_price = 20.00
            if (buildProduct?.isVzfNYDiscount || hasNYdiscount) {
                return (discountPrice < vzfwd_NY_floor_price) ? vzfwd_NY_floor_price : discountPrice
            }
            else {
                return (discountPrice < vzfwd_floor_price) ? vzfwd_floor_price : discountPrice
            }
        }
        catch (error) {
            console.log("Error in getVzfwdDisplayPrice()", error)
        }
    }

    static removeFeedback() {
        try {
            const isFiosFlow = sessionStorage && sessionStorage.getItem("fiosReferralFlow");
            const tempFeedbackHide = sessionStorage && sessionStorage.getItem("tempFeedbackHide");
            if (isFiosFlow === "true" && tempFeedbackHide === "true") {
                const element = document.getElementById("kampyleButtonContainer");
                if (element && element.style) {
                    element.style="display:none";
                } else {
                    setInterval(() => {
                        try {
                            const element = document.getElementById("kampyleButtonContainer");
                            if (element && element.style && sessionStorage && sessionStorage.getItem("tempFeedbackHide") === "true") {
                                element.style="display:none";
                            } else if (element && element.style)  {
                                element.style="display:block"
                            }
                            const feedbackElement = window.document.getElementById("QSIFeedbackButton-btn");
                            if (feedbackElement && feedbackElement.style) {
                                feedbackElement.style.display = "none";
                            }
                        } catch(ex) {
                            console.log('while removing feedback inside setInterval', ex);
                        }
                        
                    }, 400)
                }
            }
    
        } catch(ex) {
            console.log('while removing feedback', ex);
    
        }    
      }

    // This will give  productId to group them in perks (Drawer sections)
    static findGroupIdWith = (id)=>{
            if(id === constants.UNLIMITED_CLOUD_INDIVIDUAL){
                return constants.UNLIMITED_CLOUD_GROUP;
            } else  if(id === constants.APPLE_ONE_INDIVIDUAL){
                return constants.APPLE_ONE_FAMILY;
            } else  if(id === constants.HOME_DEVICE_ADVISOR){
                return constants.VERIZON_HOME_DEVICE_PROTECT;
            }else{
                return "";
            }
      }

    static searchNestedObject(obj, key, value) {
        for (const prop in obj) {
            if (typeof obj[prop] === 'object') {
                const result = InHomeUtils.searchNestedObject(obj[prop], key, value);
                if (result) {
                    return result;
                }
            } else if (prop === key && obj[prop] === value) {
                return obj;
            }
        }
        return null;
    }
}

function clearCookies(){
    var cookies = document.cookie.split("; ");
    for (var c = 0; c < cookies.length; c++) {
        var d = window.location.hostname.split(".");
        while (d.length > 0 && !cookies[c].split('=')[0] == "userinfo" &&
        !cookies[c].split('=')[0] == "vCustId" && !cookies[c].split('=')[0] == "vAcctId") {
            var cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
            var p = window.location.pathname.split('/');
            document.cookie = cookieBase + '/';
            while (p.length > 0) {
                document.cookie = cookieBase + p.join('/');
                p.pop();
            };
            d.shift();
        }
    }
  }

export const visitIdValidity = async (dispatch, commonLQFlow = false, commonLQVisitId='',commonLQVisitorId='', isMLP = false, page='') => {
    let cookie_visit_id = "";
    if(window.location.href.indexOf('localhost:3000') > -1) return true; //localDev // escape hatch for dev environment
    //dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true } });
    // const mnhresponse = await getCookieMNHIndicator();
    // if(mnhresponse && mnhresponse.data && mnhresponse.data.server_mnh_id && mnhresponse.data.server_mnh_id.toLowerCase() === 'y') {
    //     commonLQFlow = true;
    //     window.localStorage.setItem('mnh_indicator', mnhresponse.data.server_mnh_id);
    // }
    const response = await getCookieVisitIdAndVisitorId(commonLQFlow, commonLQVisitId, commonLQVisitorId);
    let result = false;
    if(response && response.data) {
        const {commonLQ, server_visit_id, expirationTime, server_visitor_id,vendorflow} = response.data;
        if(commonLQ || vendorflow === 'y' ){
            window.sessionStorage.setItem('visit_id', server_visit_id);
            window.localStorage.setItem('visit_id', server_visit_id);
            window.localStorage.setItem("expirationTime", expirationTime)
        }
        const sessVisit_id = window.sessionStorage.getItem("visit_id") || '';
        const browserVisit_id = window.localStorage.getItem("visit_id") || '' ;
        cookie_visit_id = server_visit_id  ;
        result = ((page && page === 'LQ') || (!page && cookie_visit_id)) && cookie_visit_id === sessVisit_id && cookie_visit_id === browserVisit_id;
        if(!result) {
            InHomeUtils.clearMemory();
            let qs = "";
            if ( window.location.search && (window.location.search.toLowerCase().indexOf('neworder=y') > -1)) { qs = "neworder=y" }
            else if (window.location.search && (window.location.search.toLowerCase().indexOf('lq=n') > -1)) {qs = "lq=n" }
            if(!isMLP)
                InHomeUtils.redirectToHomePage(qs);
        }
        window.localStorage.setItem("vendorflow", vendorflow);
        window.localStorage.setItem('visitor_id',server_visitor_id);
    }
    //dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    return result && cookie_visit_id;
}

export const visitIdValidity_LQ = (response) => {
    let cookie_visit_id = "";
    if(window.location.href.indexOf('localhost:3000') > -1) return true; //localDev 
    let result = false;
    if(response && response.data) {
        const {commonLQ, server_visit_id, expirationTime, server_visitor_id,vendorflow} = response.data;
        if(commonLQ || vendorflow === 'y' ){
            window.sessionStorage.setItem('visit_id', server_visit_id);
            window.localStorage.setItem('visit_id', server_visit_id);
            window.localStorage.setItem("expirationTime", expirationTime)
        }
        const sessVisit_id = window.sessionStorage.getItem("visit_id") || '';
        const browserVisit_id = window.localStorage.getItem("visit_id") || '' ;
        cookie_visit_id = server_visit_id  ;
        result =  cookie_visit_id === sessVisit_id && cookie_visit_id === browserVisit_id;
        if(!result) {
            InHomeUtils.clearMemory();
            let qs = "";
            if ( window.location.search && (window.location.search.toLowerCase().indexOf('neworder=y') > -1)) { qs = "neworder=y" }
            else if (window.location.search && (window.location.search.toLowerCase().indexOf('lq=n') > -1)) {qs = "lq=n" }
            InHomeUtils.redirectToHomePage(qs);
        }
        window.localStorage.setItem("vendorflow", vendorflow);
        window.localStorage.setItem('visitor_id',server_visitor_id);
    }
    return result && cookie_visit_id;
}

export const CommonLQValidity = async (dispatch) => {
    if(window.location.href.indexOf('localhost') > -1) return true; //localDev // escape hatch for dev environment
    //dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: true } });
    const response = await getCookieCommonLQ();
    let result = false;
    if(response && response.data) {
        const {commonLQ} = response.data;
        if(commonLQ){
            window.sessionStorage.setItem('commonLQ', commonLQ);
        }
        result = commonLQ;      
    }
    //dispatch({ type: 'LOADER_ACTIVE', value: { isLoaderActive: false } });
    return result;
}

export const getCraddleCookie = (name) => {
    var start=document.cookie.indexOf(name+'=');
    if(start < 0) return null;
    start=start+name.length+1;
    var end=document.cookie.indexOf(';', start);
    if(end < 0) end=document.cookie.length;
    while (document.cookie.charAt(start)===' '){ start++; }
    return unescape(document.cookie.substring(start,end));
}

export const parseJSON = (data) => {
    try{
        return JSON.parse(data);
    }catch(e) {
        return null;
    }
}

export const prefetchPerkImages = () => {
    try {
      const perkImgPrefetchEnabled =
        store?.getState?.()?.loopQual?.runtimeKey?.EnablePerkImagesPrefetch ===
        "Y";
      if (perkImgPrefetchEnabled) {
        const perkImages = [
          "https://ss7.vzw.com/is/image/VerizonWireless/perk-tile-net-max-1x1-small?fmt=webp",
          "https://ss7.vzw.com/is/image/VerizonWireless/perk-tile-disney-hulu-espn-bundle-1x1-small?fmt=webp",
          "https://ss7.vzw.com/is/image/VerizonWireless/perk-tile-apple-one-1x1-small?fmt=webp",
          "https://ss7.vzw.com/is/image/VerizonWireless/perk-tile-apple-music-family-1x1-small?fmt=webp",
          "https://ss7.vzw.com/is/image/VerizonWireless/perk-tile-youtube-premium-1x1-small?fmt=webp",
          "https://ss7.vzw.com/is/image/VerizonWireless/perk-tile-unlimited-cloud-storage-1x1-small?fmt=webp",
          "https://ss7.vzw.com/is/image/VerizonWireless/perk-tile-home-device-advisor-1x1-small?fmt=webp",
          "https://ss7.vzw.com/is/image/VerizonWireless/perk-tile-google-one-ai-premium-1x1-small?fmt=webp",
        ];
        perkImages.forEach((img) => {
          const newLink = document.createElement("link");
          newLink.rel = "preload";
          newLink.href = img;
          newLink.as = "image";
          document.head.appendChild(newLink);
        });
      }
    } catch (e) {
      console.error("Error in Prefetching the Perk Images", e);
    }
  };

  export const populateFootNotes = (products) => {
    try {
        const footNotesMapping = {
            "R4587": "Must maintain service in good standing and redeem offer w/in 30 days thereafter, or no later than 7.27.25, whichever is first. If service is canceled within 180 days, Verizon can charge back the Promotional Value ($400).",
            "FIOS_RAYBAN_META_GLASSES": "Must maintain service in good standing for 65 days and redeem offer w/in 60 days thereafter, or no later than 12.10.25, whichever is first. If service is canceled within 180 days, Verizon can charge back the Promotional Value (up to $299).",
            "$50_VERIZON_GC_DISCOUNT_NDMA": "Must install and maintain service in good standing for 65 days and register for the Gift Card w/in 60 days , or no later than 12.10.25, whichever is first.  If service is canceled within 180 days, Verizon can charge back the promotional value.",
            "$50_VERIZON_GIFT_CARD": "Must install and maintain service in good standing for 65 days and register for the Gift Card w/in 60 days . If service is canceled within 180 days, Verizon can charge back the promotional value.",
            "R4540": "$10/mo perk credit ends after 6 mos, if account does not stay in good standing or if service is moved to an ineligible plan during the 6-mo promo period. After 6 mos, perk bills as $10/mo unless perk is canceled or unregistered.",
            "R4611": "New Verizon Home Internet services req'd. Must remain in good standing for 65 days and redeem offer w/in 60 days thereafter, or by no later than 11.12.25, whichever is first.  If canceled during the first 180 days, Verizon may charge back the value of the Nintendo promotional device.",
            "Fios Discount": "Thru 11.14.25 , offer limited to new fiber-ready res. custs. (w/ existing Optical Network Terminal) w/ Verizon consumer postpaid mobile plans (excludes business and data-only plans). Discount applied via 12 mo bill credit; thereafter standard monthly rates apply. Auto Pay & paper-free billing req’d. Other terms apply.",
            "Amazon Gift Card": "Offer ends 6.30.25. Must maintain eligible Fios services for 65 days and redeem within 60 days thereafter.  Restrictions apply, see amazon.com/gc-legal. Promotion value charged to account if service canceled w/in 180 days.",
            "R4570" : "JBL PartyBox: Requires new activation/installation of Fios 1 Gig internet. Must maintain active service for 65 days and redeem offer w/in 60 days thereafter, or by no later than 12.10.25, whichever is first. Verizon may charge back the value of the device(s) if service is canceled w/in 180 days. One offer per eligible Verizon account. Offer vaild through 7.8.25, while supplies last. Delivery of the JBL PartyBox may take 3-5 months after redemption.",
            "R4571" : "Requires new activation/installation of Verizon Home Internet Services, which must be installed and maintained for at least 65 days to qualify. Must redeem w/in the earlier of 60 days of installation, or 1.1.26. The value of the JBL Clip 5 may be charged back to the account if service is canceled w/in 180 days. One offer per eligible Verizon account, while supplies last. Offer ends 7.30.25.",
            "Fios Internet Discount" : "Thru 9.10.25 , offer limited to new fiber-ready res. custs. (w/ existing Optical Network Terminal) w/ Verizon consumer postpaid mobile plans (excludes business and data-only plans). Discount applied via 12 mo bill credit; thereafter standard monthly rates apply. Auto Pay & paper-free billing req’d. Other terms apply.",
            "R4677" :"Must maintain service in good standing and redeem offer w/in 30 days thereafter, or no later than 8.27.25, whichever is first. If service is canceled within 180 days, Verizon can charge back the Promotional Value ($400).",
            "R4678" :"JBL PartyBox: Requires new activation/installation  of Fios 1 Gig internet. Must maintain active service for 65 days and redeem offer w/in 60 days thereafter, or by no later than 12.10.25, whichever is first. Verizon may charge back the value of the device(s) if  service is canceled w/in 180 days. One offer per eligible Verizon account.   Offer valid through 7.30.25, while supplies last. Delivery of the JBL PartyBox may take 3-5 months after redemption."
        }
        let footNotes = [];
        if (products?.length > 0) {
            products?.forEach((plan) => {
                if (plan?.specialOffers && plan?.specialOffers?.length > 0) {
                    plan?.specialOffers?.forEach((splOffer) => {
                        if (splOffer?.extendedAttributes) {
                            let alreadyPresent = "";
                            if(footNotes?.length > 0)
                            alreadyPresent = footNotes?.find(note => note?.BsOfferAttrValue === splOffer?.BsOfferAttrValue) || (splOffer?.BsOfferAttr === 'VZREWARD' && footNotes?.find(note => note?.BsOfferAttr === "VZREWARD")) || (splOffer?.OfferText?.includes('Fios Internet Discount') && footNotes?.find(note => note?.OfferText?.includes("Fios Internet Discount")))||(splOffer?.OfferText?.includes('Amazon Gift Card')&& footNotes?.find(note=>note?.OfferText?.includes('Amazon Gift Card')))||(splOffer?.OfferText?.includes('Fios Discount') && footNotes?.find(note => note?.OfferText?.includes('Fios Discount')))
                            if (!alreadyPresent && (splOffer?.extendedAttributes?.toUpperCase()?.includes("ISCHOICE:YES") || splOffer?.extendedAttributes?.toUpperCase()?.includes("TILEDISPLAY:YES"))) {
                                splOffer.footNote = footNotesMapping[splOffer?.USOCIOSC]
                                                        ? footNotesMapping[splOffer?.USOCIOSC]
                                                            : splOffer?.BsOfferAttr === "VZREWARD" ?
                                                                     (splOffer?.offerFor === "Data" && splOffer?.OfferText?.includes("Verizon Gift Card")) ?
                                                                             footNotesMapping["$50_VERIZON_GC_DISCOUNT_NDMA"]  : (splOffer?.offerFor === "Data" && splOffer?.OfferText?.includes("Amazon Gift Card")) ? footNotesMapping["Amazon Gift Card"] :
                                                                     splOffer?.offerFor === "Video" ? footNotesMapping["$50_VERIZON_GIFT_CARD"] : "" : splOffer?.OfferText?.includes("Fios Internet Discount") ? footNotesMapping["Fios Internet Discount"] :splOffer?.OfferText?.includes("Fios Discount") ? footNotesMapping["Fios Discount"]:""
                                if (splOffer.footNote) {
                                    footNotes.push(splOffer)
                                }
                            }
                        }
                    })
                }
            })
        }
        return footNotes
    }
    catch (error) {
        console.log(error, "Error in populateFootNotes()")
    }
}

export const getFootNoteOnSpecialGift = (splGift, footNotes, lqState, flowType, parseOffer = false, offerId='') => {
    try {
        let gift = splGift;
        if (lqState?.runtimeKey?.enablePromoFooterNotes === "Y" && flowType !== "SUPP" && splGift && splGift?.length > 2) {
            gift = gift?.replace("Get ", "")?.replace(" on us", "")?.replace(",", "")?.replace("and more.", "")?.replace(" on us", "")?.replace(" on us,", "");
            if (gift?.includes("Verizon Gift Card") || gift?.includes("Fios Internet Discount") || gift?.includes("Amazon Gift Card") || gift?.includes("Fios Discount")) {
                gift = gift?.replace("$50 ", "")?.replace("$100 ", "")?.replace("$150 ", "")?.replace("$200 ", "")?.replace("$10 ", "")?.replace("$15 ", "")?.replace("Bonus: ","")
            }
            const footNoteIndex = footNotes?.findIndex(offer => offer?.OfferText?.includes(gift?.trim()) || offer?.id === offerId)
            if (footNoteIndex >= 0) {
                if (parseOffer) {
                    splGift = splGift?.includes?.("JBL ") ? 'a ' + splGift: splGift;
                    return `<span>${splGift?.trim()}<sup id="footNoteOfferIndex">${footNoteIndex + 1}</sup></span>`
                }
                return <span>{splGift?.trim()}<sup id="footNoteOfferIndex">{footNoteIndex + 1}</sup></span>
            } else {
                return splGift
            }
        }
        return splGift;
    }
    catch (error) {
        console.log(error, 'error in getFootNoteOnSpecialGift()')
    }
}

export const checkNewPerksMvSeamless = (profilePerks = [], currentPerks = []) => {
    try {
        if (currentPerks?.length > 0 && profilePerks?.length > 0) {
            for(const cPerk of currentPerks ){
                const isPerkPresentInProfile = profilePerks?.find(pPerk => pPerk?.prodTypeVal === cPerk?.prodTypeVal);
                if (!isPerkPresentInProfile) {
                    return true;
                }
            }
            return false;
        }
        return !(currentPerks?.length === 0)
    }
    catch (error) {
        console.log("Error in checkNewPerksMvSeamless", error)
    }
}
const isAlpha = (ch) => (/[a-zA-Z]/).test(ch);
export const capitalizeFirstLetterofWord = (text) => {
    if (text && isAlpha(text)) {
      const words = text?.toLowerCase()?.split(' ');
      if (words?.length > 0) {
        return words?.map((word) => (word?.[0]?.toUpperCase() || '') + word?.slice(1))?.join(' ');
      }
    }
    return text;
  };
